import type { TimelineEntityTypeFilter } from "../../api/useGetActivityTimeline";

export type { TimelineEntityTypeFilter };

type Props = {
  currentFilter: TimelineEntityTypeFilter;
  onFilterChange: (filter: TimelineEntityTypeFilter) => void;
};

export function useActivityTimelineFilter(props: Props) {
  function handleSelect(filter: TimelineEntityTypeFilter) {
    props.onFilterChange(filter);
  }

  return {
    handleSelect,
  };
}
